import { LegalPage } from "./legal/LegalPage";
import CommunityGuidelinesDocument from "./dynamic/CommunityGuidelines";

export default function CommunityGuidelinesComponent() {
  return (
    <LegalPage path="/communityguidelines">
      <CommunityGuidelinesDocument />
    </LegalPage>
  );
}
